<template>
<span>
  <v-navigation-drawer
    permanent dark app
    :mini-variant="mini"
    class="spinelab-website-front">
    <v-list>
      <v-list-tile>
        <v-list-tile-content v-if="!mini" />
        <v-list-tile-action>
          <v-btn icon @click.native.stop="mini = !mini">
            <v-icon>{{ mini ? 'chevron_right' : 'chevron_left' }}</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
      <template v-if="!mini">
        <v-list-tile>
          <v-list-tile-title>
            サイトのステータス
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content :class="$style['public-status']">
            <v-list-tile-title class="title">
              <v-layout align-center justify-center>
                {{loading ? '更新中' : isPublic ? '公開中': '非公開'}}
              </v-layout>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>
            <v-list-tile-title>
              <a @click="changePublicStatus()" :class="$style.a" v-if="!loading">
                {{isPublic ? '非公開にする': '公開する'}}
              </a>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
    <v-divider v-if="!mini" />
    <v-list v-if="!mini">
      <v-list-tile v-for="item in items"
                   :key="item.path"
                   @click="clicked(item)">
        <v-list-tile-content>
          <v-list-tile-title>{{item.name}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider v-if="!mini" />
    <v-list v-if="!mini">
      <v-list-tile href="static/pdf/manual.pdf" target="_blank">
        <v-list-tile-content>
          <v-list-tile-title :class="$style['pdf-guide']">ご利用ガイド</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile href="static/getting_help.html" target="_blank">
        <v-list-tile-content>
          <v-list-tile-title>困ったときは</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
  <router-view v-if="initiated" />
</span>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

const items = [
  { path: 'basic', name: '基本情報' },
  { path: 'layout', name: 'サイトレイアウト' },
  { path: 'update-template', name: 'テンプレート変更' },
  { path: 'contact', name: 'お問合せの管理' },
  { path: 'export-pdf', name: '会社案内出力' },
  { path: '/login', name: 'ログアウト' },
];

export default {
  name: 'Website',
  data() {
    return {
      initiated: false,
      mini: false,
      loading: false,
      items,
    };
  },
  computed: {
    ...mapState({
      isPublic: state => state.site && state.site.is_opened,
    }),
    ...mapGetters(['isAdminLogined']),
  },
  methods: {
    ...mapActions(['logout', 'setSite', 'setSiteInformation', 'changeOpenStatus', 'showAlert']),
    async clicked(item) {
      if (item.path === '/login') {
        this.initiated = false;
        await this.logout();
        if (this.isAdminLogined) {
          this.$router.push({ name: 'AdminUsers' });
          return;
        }
      }
      this.$router.push(item.path);
    },
    async changePublicStatus() {
      this.loading = true;
      await this.changeOpenStatus();
      this.loading = false;
    },
  },
  async created() {
    await Promise.all([
      this.setSiteInformation(),
      this.setSite(),
    ]);
    this.initiated = true;
  },
};
</script>

<style module>
.public-status {
  outline: 1px solid white;
}
.a {
  color: white;
  text-decoration: underline;
}
.pdf-guide {
}
</style>



// WEBPACK FOOTER //
// src/components/Website.vue